import { render, staticRenderFns } from "./staffDashboard.vue?vue&type=template&id=5fc1b6fc&scoped=true"
import script from "./staffDashboard.vue?vue&type=script&lang=js"
export * from "./staffDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1b6fc",
  null
  
)

export default component.exports